/**
 * Calculate age from birthday string
 */
export const calculateAge = (birthdayStr: string | undefined): number | null => {
  if (!birthdayStr) return null;
  try {
    const birthDate = new Date(birthdayStr);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  } catch {
    return null;
  }
};

/**
 * Format array for display (capitalize and join)
 */
export const formatArray = (arr: string[] | string): string => {
  if (Array.isArray(arr)) {
    if (arr.length === 0) return '';
    return arr.map(item => 
      item.replace(/_/g, ' ').split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ')
    ).join(', ');
  }
  return arr ? arr.replace(/_/g, ' ').split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ') : '';
};

/**
 * Format value for display
 */
export const formatValue = (value: any): string => {
  if (value === undefined || value === null) return 'N/A';
  if (Array.isArray(value)) {
    return value.length > 0 ? formatArray(value) : 'N/A';
  }
  if (typeof value === 'number') return value.toString();
  return formatArray(value) || 'N/A';
};

